onReady(() => {
    document.querySelectorAll('.case-study-slider')
        .forEach((sliderWrapper) => {
            const slider = sliderWrapper.querySelector('.slider');
            if (!slider) {
                return;
            }
            const cards = sliderWrapper.querySelectorAll('.slider-section');
            const sliderDots = sliderWrapper.querySelector('.slider-dots');
            const cardCount = cards.length;
            const prevArrow = sliderWrapper.querySelector('.arrow.prev');
            const nextArrow = sliderWrapper.querySelector('.arrow.next');
            const slideIntervalDelay = 10000;
            let index = 0;
            let slideInterval = null;

            function cardsToShow() {
                if (window.innerWidth <= 660) {
                    return 1;
                }
                if (sliderWrapper.classList.contains('three-visible-cards')) {
                    return 3;
                }
                if (sliderWrapper.classList.contains('two-visible-cards')) {
                    return 2;
                }
                if (window.innerWidth <= 1049) {
                    return 2;
                }
                return 1;
            }

            const createCardClones = () => {
                const cardsPerSlide = cardsToShow();
                const numberCardsToClone = cardsPerSlide;
                const clonedCards = slider.querySelectorAll('.card-clone');

                // Bail if have the appropriate amount of card clones already
                if (numberCardsToClone === clonedCards.length) {
                    return;
                }

                // Remove cloned cards
                clonedCards.forEach((card) => card.remove());

                // Add card clones
                for (let cardIndex = 0; cardIndex < numberCardsToClone; cardIndex++) {
                    const clonedCard = cards[cardIndex].cloneNode(true);
                    clonedCard.classList.add('card-clone');
                    slider.appendChild(clonedCard);
                }
            }

            function animateSlide(start, end) {
                const slideWidth = 100 / cardsToShow();
                return slider.animate(
                    [
                        {transform: `translateX(-${start * slideWidth}%)`},
                        {transform: `translateX(-${end * slideWidth}%)`},
                    ],
                    {
                        duration: 200,
                        fill: 'forwards',
                    },
                );
            }

            function dotPosition() {
                const dots = sliderDots.querySelectorAll('.dot');
                const currentDotCount = dots.length;
                if (currentDotCount === 0) {
                    return;
                }

                const activeDot = index >= cardCount ? 0 : index;
                dots.forEach(
                    (dot, slideIndex) => dot.classList.toggle('active', slideIndex === activeDot),
                );
            }

            function prevSlide() {
                stopAutoScroll();
                const previousSlide = index;
                index--;
                if (index < 0) {
                    // Move to back of cards list if we "previous" on the first card
                    index = cardCount - 1;
                }
                animateSlide(previousSlide, index);
                dotPosition();
                startAutoScroll();
            }

            function nextSlide() {
                stopAutoScroll();
                const previousSlide = index;
                index++;
                animateSlide(previousSlide, index).onfinish = () => {
                    if (index >= cardCount) {
                        // Double RAF to ensure this animation only happens after the previous has completed
                        requestAnimationFrame(() => requestAnimationFrame(() => slider.animate(
                            [{transform: 'translateX(0%)'}],
                            {fill: 'forwards'},
                        )))
                        index = 0;
                    }
                };
                dotPosition();
                startAutoScroll();
            }

            if (cardCount < 2) {
                prevArrow.classList.add('hidden');
                nextArrow.classList.add('hidden');
                slider.classList.add('single-card');
                return;
            }

            const startAutoScroll = () => slideInterval = setInterval(nextSlide, slideIntervalDelay);
            const stopAutoScroll = () => {
                clearInterval(slideInterval);
                slideInterval = null;
            };
            startAutoScroll();
            document.addEventListener('visibilitychange', () => {
                if (document.hidden) {
                    stopAutoScroll();
                    return;
                }
                if (slideInterval == null) {
                    startAutoScroll();
                }
            });

            if (prevArrow) {
                prevArrow.addEventListener('click', prevSlide);
            }
            if (nextArrow) {
                nextArrow.addEventListener('click', nextSlide);
            }

            function createDots() {
                sliderDots.innerHTML = '';
                if (cardCount <= 1) {
                    return;
                }
                for (let dotIndex = 0; dotIndex < cardCount; dotIndex++) {
                    const dot = document.createElement('button');
                    dot.classList.add('dot');
                    if (dotIndex === 0) {
                        dot.classList.add('active');
                    }
                    dot.addEventListener('click', () => {
                        animateSlide(index, dotIndex);
                        index = dotIndex;
                        dotPosition();
                    });
                    sliderDots.appendChild(dot);
                }
            }

            createDots();
            createCardClones();
            let windowWidth = window.innerWidth;
            window.addEventListener('resize', debounce(() => {
                if (windowWidth === window.innerWidth) {
                    // this is triggered by mobile browser, no resize happened
                    // Happens when the browser's navigation elements show/hide
                    return;
                }
                windowWidth = window.innerWidth;
                nextSlide();
                createCardClones();
            }, 200));
        });
});
